// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pj-1";
export var stateContainer = "_pj-0";